<template>
  <div class="role-authority">
    <div class="role-authority-container">
      <div class="left-container">
        <div
          :class="activeIndex === index?'active role':'role'"
          v-for="(item, index) in roleList"
          :key="index"
          @click="selectRoleId(item, index)"
        >
          <span class="img"></span>
          <span class="role-name">{{ item.roleName }}</span>
        </div>
      </div>
      <div class="right-container">
        <div class="top-container" v-if="roleName">
          <div class="title">{{ roleName }}</div>
          <div class="search">
            <el-input
              class="gray white w256"
              placeholder="搜索员工名"
              prefix-icon="el-icon-search"
              v-model="searchStaff"
              clearable
              @keyup.enter.native="searchPeople"
            >
            </el-input>
            <el-button
              type="text"
              class="btn-blue add"
              icon="el-icon-plus"
              @click="add"
              >添加</el-button>
          </div>
        </div>
        <div class="table" v-if="tableData.length > 0">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              v-for="(item, index) in tableTitleList"
              :key="index"
              :prop="item.prop"
              :label="item.lable"
              :width="item.width"
            />
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" class="btn-text-red" @click="remove(scope.row)">删除</el-button>
            </template>
          </el-table-column>
          </el-table>
          <div class="pagination-tpl-container">
            <pagination-tpl
              :total="totalNum"
              :currentPage="currentPage"
              @queryChange="onQueryChange"
            ></pagination-tpl>
          </div>
        </div>
        <div class="nothing" v-if="tableData.length == 0">
          <div class="nothing-left">
            <h1>什么是角色？</h1>
            <ul>
              <li>
                角色指团队成员的专业分工类别，可由1位或多位成员
                组成，如模块管理员、财务审核人、工薪制表人等。
              </li>
              <li>
                目前，“角色”仅运用于审批应用的流程设计。在审批管
                理后台，管理员可选择成员成为某种“角色”从而进行审
                批操作，如选择张某某成为“财务审核人”作为报销流程
                的财务审核人进行审批工作。
              </li>
              <li>
                用“角色”作为审批人，可避免因成员离职变动，审批流
                失效的情况。该“角色”中的剩余成员可继续完成该审批， 提高审批效率。
              </li>
            </ul>
          </div>
          <div class="nothing-right">
            <div>
              <img src="../../../assets/role-nothing.png" />
            </div>
            <p>报销审批流程</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 添加角色成员 -->
    <el-dialog
      title="添加角色成员"
      :visible.sync="stayDistributionDialogVisible"
      width="540px"
      :before-close="stayDistributionClose"
    >
      <div class="stayDistribution">
        <div class="table-right">
          <p class="title">每次最多可添加1个成员</p>
          <tree-people
            :companyList="companyList"
            :departmentId="departmentId"
            @selectTreeNodeList="selectDepartmentList"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="stayDistributionClose"
          >取 消</el-button
        >
        <el-button type="primary" @click="stayDistributionConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import TreePeople from "@/components/tree-people.vue";
import PaginationTpl from "@/components/PaginationTpl.vue";
import Role from "@/models/role.js";
import { mapChild } from "@/common/js/utils.js";
import { getTeamId } from "common/js/storage";
import Staff from "@/models/staff.js";
export default {
  components: {
    TreePeople,
    PaginationTpl
  },

  data() {
    return {
      roleList: [],
      tableData: [],
      totalNum: 0,
      currentPage: 1,
      tableTitleList: [
        { prop: "name", lable: "姓名", width: "" },
        { prop: "phone", lable: "手机号", width: "" },
        { prop: "department", lable: "所属部门", width: "" },
        { prop: "controlLimit", lable: "管理范围", width: "" },
      ],
      roleName: "",
      searchStaff: "",
      activeIndex: "",
      stayDistributionDialogVisible: false,
      companyList: [] /* 变更部门数据 */,
      departmentId: 0,
      selectType: null,
      selectRole: null,
      userId: null,
      deptId: null,
    };
  },

  created() {
    config()
    this.initOneLevelRoleList();
    this.initDepartmentList()
  },
  mounted() {
    this.$nextTick(() => {
      this.$bus.emit("isShowTopMenu", false);
    });
  },

  methods: {
    /* 一级权限列表 */
    initOneLevelRoleAuthorityList() {
      let name = this.searchStaff
      let currentPage = this.currentPage
      Role.getOneLevelRoleAuthorityList(name, currentPage).then(res => {
        if (res.success) {
          this.totalNum = res.result.totalNum
          let arr = [];
          res.result.items.map((i) => {
            let obj = {};
            obj.userId = i.userId;
            obj.name = i.name ? i.name : "—";
            obj.phone = i.phoneNo ? i.phoneNo : "—";
            obj.department = i.deptName ? i.deptName : "—";
            obj.managementScope = i.managementScope
            let controlLimit = []
            if (i.managementScope) {
              i.managementScope.map(v => {
                controlLimit.push(v.teamName)
              })
            }
            if (controlLimit.length > 0) {
              obj.controlLimit = controlLimit.join(';')
            } else {
              obj.controlLimit = "—";
            }
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 一级角色列表 */
    initOneLevelRoleList() {
      Role.getOneLevelRoleList().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.roleId = i.roleId;
            obj.roleName = i.name;
            obj.type = i.type;
            arr.push(obj);
          });
          this.roleList = arr;
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取部门数据 */
    initDepartmentList() {
      let searchDepartment = ''
      let id = getTeamId() ? getTeamId() : 1
      Staff.getDepartmentPeopleList(id, searchDepartment).then(res => {
        if (res.success) {
          this.companyList = mapChild(res.result);
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    searchPeople() {
      this.currentPage = 1;
      this.initOneLevelRoleAuthorityList();
    },

    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initOneLevelRoleAuthorityList();
    },

    /* 选择角色 */
    selectRoleId(row, index) {
      this.activeIndex = index
      this.roleName = row.roleName
      this.selectType = row.type
      this.selectRole = row.roleId
      this.initOneLevelRoleAuthorityList();
    },

    /* 一级删除二级管理员 */
    _postDelOneLevelRoleAuthority(data) {
      Role.postDelOneLevelRoleAuthority(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '删除成功'
          });
          this.initOneLevelRoleAuthorityList();
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    remove(row) {
      this.$confirm("角色成员删除后不可恢复，是否继续？", "确认删除成员", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        let userId = row.userId
        let data = {
          userId,
        }
        this._postDelOneLevelRoleAuthority(data)
      });
    },
    
    /* ----------------------------------  以下是添加角色成员方法 ------------------------ */
    /* 添加 */
    add() {
      if (this.roleName) {
        this.userId = '';
        this.departmentId = 0,
        this.stayDistributionDialogVisible = true;
      } else {
        this.$message({
          type: 'error',
          message: '请先选择角色'
        });
      }
    },

    /* 一级添加二级管理员 */
    _postAddOneLevelRoleAuthority(data) {
      Role.postAddOneLevelRoleAuthority(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '添加成功'
          });
          this.initOneLevelRoleAuthorityList();
          this.stayDistributionClose()
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    stayDistributionClose() {
      this.stayDistributionDialogVisible = false;
      this.$bus.emit('clearSelect', 0)
    },

    stayDistributionConfirm() {
      if (!this.userId) {
        this.$message({
          type: "error",
          message: "请先选择成员",
        });
        return
      }
      let userId = this.userId
      let deptId = this.deptId
      let data = {
        userId,
        deptId
      }
      this._postAddOneLevelRoleAuthority(data)
    },

    selectDepartmentList(v) {
      this.userId = v.id2
      this.deptId = v.id.split('|')[1]
    }
  },
};
</script>

<style lang='scss' scoped>
.role-authority {
  flex: 1;
  background: $bg-white;
  .role-authority-container {
    display: flex;
    height: 100%;
  }
  .left-container {
    width: 288px;
    padding: 16px;
    box-sizing: border-box;
    border-right: 1px solid $bg-ShallowLightSnow;
    .role {
      height: 40px;
      padding: 0px 16px;
      font-size: $fs-small-l;
      @include flex-start;
      cursor: pointer;
      .img {
        width: 16px;
        height: 16px;
        margin-right: 20px;
        background: url("../../../assets/role.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .role-name {
        height: 40px;
        line-height: 40px;
        @include two-wrap-ellipsis(1);
      }
      &:hover {
        background: $bg-ChangeDepartmentHighTree;
        color: $color-ReddishBlue;
        .img {
          background: url("../../../assets/role-high.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .active {
      background: $bg-ChangeDepartmentHighTree;
      color: $color-ReddishBlue;
      .img {
        background: url("../../../assets/role-high.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .right-container {
    flex: 1;
    padding: 16px 20px;
    position: relative;
    .top-container {
      @include flex-between;
      margin-bottom: 20px;
      .title {
        padding-left: 10px;
        font-size: $fs-medium-s;
        color: $color-BlackGrey;
        border-left: 4px solid $color-DeepReddishBlue;
      }
      .search {
        display: flex;
        .add {
          margin-left: 12px;
          padding: 0;
        }
      }
    }
    .nothing {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      @include flex-center;
      .nothing-left {
        width: 350px;
        margin-right: 30px;
        h1 {
          text-align: left;
        }
        ul {
          font-size: $fs-small-l;
          font-weight: 400;
          color: $color-grey;
          text-align: left;
          li {
            margin-bottom: 21px;
            line-height: 20px;
          }
        }
      }
      img {
        width: 270px;
        height: 390px;
      }
      p {
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-LightGrey;
        margin-top: 24px;
      }
    }
  }
  
  .stayDistribution {
    height: 300px;
    overflow-y: auto;
    margin: 16px;
    background: $bg-ChangeDepartmentTree;
    .el-input__prefix, .el-input__suffix {
      top: 2px;
    }
    .table-right {
      background: $bg-ChangeDepartmentTree;
      box-sizing: border-box;
      overflow: hidden;
      .title {
        height: 36px;
        font-weight: 400;
        line-height: 36px;
        border-radius: 2px;
        margin-bottom: 14px;
        text-align: left;
        padding-left: 28px;
        font-size: $fs-small-l;
        color: $color-OriginYellow;
        background: $bg-OriginYellow;
      }
    }
  }
}
</style>
<style lang="scss">
.role-authority {
  .stayDistribution {
    .tree-people {
      padding: 0px 20px;
      .el-tree {
        background: $bg-ChangeDepartmentTree;
      }
      .search {
        .el-input__inner {
          background: $bg-ChangeDepartmentTree;
        }
      }
    }
  }
  .search {
    .el-input__prefix, .el-input__suffix {
      top: 3px;
    }
  }
}
</style>
